import { Link } from "react-router-dom";
import { Landmark, LineChart, Briefcase, Home, Car, ArrowUpRight } from "lucide-react";
import { TID } from "../../lib/testIds";

const ICONS = { Landmark, LineChart, Briefcase, Home, Car };

export function CategoryGrid({ categories }) {
  return (
    <section className="mml-section bg-white">
      <div className="mml-container">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div className="max-w-2xl">
            <p className="mml-overline">Explore by topic</p>
            <h2 className="mt-2 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              Five categories. One clear way to think about your money.
            </h2>
          </div>
          <Link to="/calculators" className="mml-link text-sm">
            See all calculators →
          </Link>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat, idx) => {
            const Icon = ICONS[cat.icon] || Landmark;
            return (
              <Link
                key={cat.slug}
                to={`/${cat.slug}`}
                data-testid={TID.categoryCard(cat.slug)}
                className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white p-7 transition-all duration-200 hover:-translate-y-[3px] hover:border-emerald-300 hover:shadow-lg"
                style={{ animationDelay: `${idx * 60}ms` }}
              >
                <div className="flex items-start justify-between">
                  <span className="grid h-12 w-12 place-items-center rounded-xl bg-emerald-50 text-emerald-700 transition-colors group-hover:bg-emerald-100">
                    <Icon className="h-6 w-6" strokeWidth={1.75} />
                  </span>
                  <ArrowUpRight className="h-5 w-5 text-slate-300 transition-colors group-hover:text-emerald-600" />
                </div>
                <h3 className="mt-5 text-xl font-bold tracking-tight text-slate-900">
                  {cat.name}
                </h3>
                <p className="mt-1 text-sm font-medium text-emerald-700">
                  {cat.tagline}
                </p>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                  {cat.description}
                </p>
                <span className="mt-6 inline-flex items-center text-sm font-semibold text-emerald-700">
                  Explore {cat.name} →
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
